import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Icon, Menu, SemanticICONS } from 'semantic-ui-react';

const styles = StyleSheet.create({
    sidebarButton: {
        backgroundImage: 'linear-gradient(to right, #3C9700 , #66B100)',
        ':hover': {
            backgroundImage: 'none',
            backgroundColor: '#3C9700',
        },
        ':active': {
            backgroundImage: 'none',
            backgroundColor: '#286400',
        },
    },
});

interface SideBarItemProps {
    active: boolean;
    menuIcon: SemanticICONS;
    menuText: string;
    onClick?: React.MouseEventHandler;
    requiredPermission?: string;
}

export default function SidebarItem(props: SideBarItemProps) {
    const { active, onClick, menuIcon, menuText } = props;
    return (
        <Menu.Item
            as="a"
            className={css(styles.sidebarButton)}
            id="sidebarButton"
            active={active}
            onClick={onClick}>
            <Icon name={menuIcon} />
            {menuText}
        </Menu.Item>
    );
}
